import { useState } from "react";

import { signIn } from "@/utils/hooks/useFirebaseAuth";
import { Text } from "@/components/atoms/Text";
import { Button } from "@/components/atoms/Button";
import { ButtonLayouts, ButtonVariant } from "@/components/atoms/Button/types";

import styles from "./LoginPage.module.scss";

function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSignIn = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    try {
      await signIn(email, password);
    } catch (err) {
      setError("Failed to sign in. Please check your credentials.");
      console.error(err);
    }
  };

  return (
    <div className={styles["page-container"]}>
      <div className={styles["login-container"]}>
        <Text variant="h2" className={styles["title"]}>
          Sign In
        </Text>
        <form onSubmit={handleSignIn}>
          <div className={styles["input-group"]}>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className={styles.input}
            />
          </div>
          <div className={styles["input-group"]}>
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className={styles.input}
            />
          </div>
          {error && <div className={styles["error"]}>{error}</div>}
          <Button
            variant={ButtonVariant.Primary}
            className={styles["button"]}
            type="submit"
            disabled={!email || !password}
          >
            Sign In
          </Button>
        </form>
      </div>
    </div>
  );
}

export { LoginPage };
